import { Stack, Typography } from "@mui/material";
import { pluralize } from "@entrilia/shared/utilities/stringHelper.ts";
import UsedByReportsGrid from "./UsedByReportsGrid.tsx";
import type { UsedByReport } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  reports: UsedByReport[];
  hiddenReportsCount: number;
  minRows: number;
  maxRows: number;
}

const UsedByReports = ({ reports, hiddenReportsCount, minRows, maxRows }: Props) => {
  if (reports.length === 0) {
    return (
      <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
        {hiddenReportsCount > 0
          ? `Used by ${hiddenReportsCount} ${pluralize("report", hiddenReportsCount)} you don’t have access to`
          : "No usages found!"}
      </Typography>
    );
  }
  return (
    <Stack useFlexGap spacing={2} sx={{ width: "100%", alignItems: "start" }}>
      <Typography variant="subtitle2">{`${reports.length} ${pluralize("report", reports.length)}`}</Typography>
      <UsedByReportsGrid reports={reports} minRows={minRows} maxRows={maxRows} />
      {hiddenReportsCount > 0 && (
        <Typography color="textSecondary">
          {`and ${hiddenReportsCount} more ${pluralize("report", hiddenReportsCount)} you don’t have access to`}
        </Typography>
      )}
    </Stack>
  );
};

export default UsedByReports;
